import React, { Fragment, useMemo } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { ClockIcon, SunIcon, MoonIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

const OPTIONS = [
  { value: "all",   label: "Tutti gli orari",  Icon: ClockIcon },
  { value: "day",   label: "Orario diurno",    Icon: SunIcon   },
  { value: "night", label: "Orario notturno",  Icon: MoonIcon  },
];

export default function TimeRangeSelect({
  selectedTimeRange = "all",
  handleTimeRangeChange,
  className = "",
}) {
  const selected = useMemo(
    () => OPTIONS.find(o => o.value === selectedTimeRange) ?? OPTIONS[0],
    [selectedTimeRange]
  );

  return (
    <div className={`relative w-full min-w-[200px] ${className}`}>
      <Listbox value={selected} onChange={(opt) => handleTimeRangeChange?.(opt.value)}>
        <div className="relative">
          {/* BUTTON */}
          <Listbox.Button
            className="
              relative w-full cursor-pointer rounded-lg bg-white
              px-3 py-1.5 text-left text-sm text-gray-600
              hover:bg-indigo-50 border border-gray-200
              focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/60
            "
          >
            <span className="flex items-center gap-2 truncate">
              {selected?.Icon && <selected.Icon className="h-5 w-5 text-gray-500" />}
              <span className="truncate">{selected?.label ?? "Seleziona orario"}</span>
            </span>

            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
            </span>
          </Listbox.Button>

          {/* OPTIONS */}
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options
              className="
                absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1
                text-sm shadow-lg ring-1 ring-black/5 focus:outline-none
              "
            >
              {OPTIONS.map((opt) => (
                <Listbox.Option
                  key={opt.value}
                  value={opt}
                  className={({ active }) =>
                    `
                      relative cursor-pointer select-none px-3 py-2
                      ${active ? "bg-indigo-50 text-gray-600" : "text-gray-600"}
                    `
                  }
                >
                  {({ selected: isSel }) => (
                    <div className="flex items-center gap-2">
                      <opt.Icon className="h-5 w-5 text-gray-500" />
                      <span className={`truncate ${isSel ? "font-semibold" : "font-normal"}`}>
                        {opt.label}
                      </span>
                    </div>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}